import { Form } from '@unform/web';
import styled from 'styled-components';

export const FormWrapper = styled(Form)`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2.4rem;
  column-gap: 6.4rem;
`;

export const InputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p {
    font-size: 1.4rem;
    opacity: 0.65;
    color: ${({ theme }) => theme.colors.black};
    user-select: none;
    padding: 0 0 0.6rem 1.2rem;
  }
`;
